import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { apiService } from '../../services/api';
import ChatWidget from './ChatWidget';

interface EventChatIntegrationProps {
  eventId: number;
  eventTitle: string;
  eventSlug: string;
  className?: string;
}

const EventChatIntegration: React.FC<EventChatIntegrationProps> = ({
  eventId,
  eventTitle,
  eventSlug,
  className = ''
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleStartPrivateChat = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await apiService.chat.startEventChat(eventId, 'private');
      
      if (response.success) {
        // Redirect to chat page
        window.location.href = `/chat/${response.chat_room.id}/`;
      } else {
        setError('Failed to start private chat');
      }
    } catch (err: any) {
      setError(err.message || 'Failed to start private chat');
    } finally {
      setLoading(false);
    }
  };

  const handleStartPublicChat = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await apiService.chat.startEventChat(eventId, 'public');
      
      if (response.success) {
        // Redirect to chat page
        window.location.href = `/chat/${response.chat_room.id}/`;
      } else {
        setError('Failed to start public chat');
      }
    } catch (err: any) {
      setError(err.message || 'Failed to start public chat');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`event-chat-integration ${className}`}>
      <Dropdown>
        <Dropdown.Toggle 
          variant="primary" 
          id="chat-dropdown"
          disabled={loading}
        >
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Starting Chat...
            </>
          ) : (
            <>
              <i className="fas fa-comments me-2"></i>
              Start Chat
            </>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={handleStartPrivateChat} disabled={loading}>
            <i className="fas fa-user me-2"></i>
            Private Chat with Organizer
          </Dropdown.Item>
          <Dropdown.Item onClick={handleStartPublicChat} disabled={loading}>
            <i className="fas fa-users me-2"></i>
            Public Discussion
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as="div">
            <small className="text-muted">
              Private: Direct message with event organizers<br/>
              Public: Chat with other attendees
            </small>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {error && (
        <div className="alert alert-danger mt-2" role="alert">
          <i className="fas fa-exclamation-triangle me-2"></i>
          {error}
        </div>
      )}

      {/* Chat Widget for quick access */}
      <div className="mt-3">
        <ChatWidget 
          eventId={eventId}
          eventTitle={eventTitle}
        />
      </div>
    </div>
  );
};

export default EventChatIntegration;
